import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { useEffectOnce } from 'react-use'
import { ROUTER_BASE_NAME } from '@/configs/env'
import { BrowserRouter as Router } from 'react-router-dom'

import { OverlayConfigProvider } from '@bcz/ink'
import { configStore } from '@/store'
import { registerAjaxHooks } from '@/helpers/registerAjaxHooks'
import { RouteConfig } from '@/RouteConfig'
import '@bcz/bczdin'
import '@bcz/bczdin/number.css'
const store = configStore()

function App() {
  useEffectOnce(() => registerAjaxHooks().unregister)

  return (
    <Provider store={store}>
      <OverlayConfigProvider>
        <Suspense fallback={null}>
          <Router basename={ROUTER_BASE_NAME}>
            <RouteConfig />
          </Router>
        </Suspense>
      </OverlayConfigProvider>
    </Provider>
  )
}

export default App
